/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.familias': 'Familias',
'familias.agregarFamilias': 'Create Familias',
'familias.modificarFamilias': 'Edit Familias',
'familias.eliminarFamilias': 'Delete Familias',
'familias.familiaId': 'Familia   Id ',
'familias.empresaId': ' Empresa   Id ',
'familias.familiaDescripcion': ' Familia   Descripcion',
'familias.familias': 'Familias',
'familias.verFamilias': 'View Familias',
};

